module.exports = __webpack_public_path__ + "static/assets/24cfc95ce91ed56ad7b062229af89140.svg";